import { render } from "./Objetivo.vue?vue&type=template&id=29ef938a"
import script from "./Objetivo.vue?vue&type=script&lang=js"
export * from "./Objetivo.vue?vue&type=script&lang=js"

import "./Objetivo.vue?vue&type=style&index=0&id=29ef938a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__